import i18n from "../i18n";

export const CAPTCHA_ERROR_CODES = [
  "captcha_required",
  "captcha_invalid",
  "captcha_expired",
  "captcha_service_unavailable",
  "verification_required",
  "verification_expired",
  "verification_invalid",
] as const;

export type CaptchaErrorCode = (typeof CAPTCHA_ERROR_CODES)[number];

const CAPTCHA_ERROR_I18N_KEYS: Record<CaptchaErrorCode, string> = {
  captcha_required: "auth.captcha.required",
  captcha_invalid: "auth.captcha.invalid",
  captcha_expired: "auth.captcha.expired",
  captcha_service_unavailable: "auth.captcha.serviceUnavailable",
  verification_required: "auth.captcha.verificationRequired",
  verification_expired: "auth.captcha.verificationExpired",
  verification_invalid: "auth.captcha.verificationInvalid",
};

function isCaptchaErrorCode(code: string): code is CaptchaErrorCode {
  return code in CAPTCHA_ERROR_I18N_KEYS;
}

export function getCaptchaErrorMessage(
  error?: string | null,
  errorCode?: string | null,
): string {
  if (errorCode && isCaptchaErrorCode(errorCode)) {
    return i18n.t(CAPTCHA_ERROR_I18N_KEYS[errorCode]);
  }

  return error || i18n.t("auth.captcha.invalid");
}
